<script setup>
    import MainHeader from '@/components/HeaderComponent.vue';
    import { useRouter } from 'vue-router';
    import { useLoginStore } from '@/stores/login/loginStore';

    const router = useRouter();

    const loginStore = useLoginStore();
    function backToLogin() {
        router.push({ name: 'login', query: { vid: loginStore.vendorId } });
    }
</script>

<template>
    <section id="main" class="login extra">
        <MainHeader />
        <div id="contents" class="small">
            <h2>{{ $t('signinUseridComplete.parts.pageTitle1') }}</h2>
            <h3>{{ $t('signinUseridComplete.parts.pageInformation1') }}<br />{{ $t('signinUseridComplete.parts.pageInformation2') }}</h3>
            <ul class="btnArea" style="padding-top: 30px">
                <li>
                    <button type="button" class="btnPrimary" @click="backToLogin">{{ $t('signinUseridComplete.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
